import config from '@nn-design-system/config/web';
import { getColor as getAliasColor, getBackgroundColor as getAliasBackgroundColor, getBorderColor as getAliasBorderColor, getAccentColor as getAliasAccentColor, getOutlineColor as getAliasOutlineColor, getTextDecorationColor as getAliasTextDecorationColor, } from './colors.alias';
import Transformer from '../transformations/web';
export function getColor() {
    return getAliasColor(new Transformer(), config);
}
export function getBackgroundColor() {
    return getAliasBackgroundColor(new Transformer(), config);
}
export function getBorderColor() {
    return getAliasBorderColor(new Transformer(), config);
}
export function getAccentColor() {
    return getAliasAccentColor(new Transformer(), config);
}
export function getOutlineColor() {
    return getAliasOutlineColor(new Transformer(), config);
}
export function getTextDecorationColor() {
    return getAliasTextDecorationColor(new Transformer(), config);
}
